import React, { Fragment, useContext, useMemo, useState } from 'react';

import { Box, Divider, Flex, Hide, Show } from '@chakra-ui/react';
import { useRouter } from 'next/router';

import style from './Sidebar.style';
import Steps from './Steps';

import { Icon, Link, Text } from '@/components';
import { HeaderDataType } from '@/components/layouts/SidebarLayout/SidebarLayout.type';
import { fetchUrlFromWindowPathName, urlArray } from '@/helpers/utils';
import useTranslation from '@/hooks/useTranslate';
import { DashboardContext } from '@/providers/DashboardContext';
import { Context } from '@/providers/MainContext';
import { LinkType } from '@/types/ContentFul.type';

interface sideBarProps {
  isMenuOpen: boolean;
  setIsMenuOpen: any;
  data?: HeaderDataType;
}

const DashboardSidebar = ({
  isMenuOpen,
  setIsMenuOpen,
  data,
}: sideBarProps) => {
  const { t } = useTranslation();
  const { serviceStages } = useContext(DashboardContext);
  const { locale } = useContext(Context);
  const [currentSelected, setCurrentSelected] = useState(0);
  const router = useRouter();
  const handleToggleMenu = () => {
    setCurrentSelected(-1);
    setIsMenuOpen.toggle();
  };

  const handleLinkOpen = () => {
    handleToggleMenu();
  };

  const currentUrl = useMemo(
    () => fetchUrlFromWindowPathName(router?.pathname, locale),
    [router.pathname, locale]
  );

  const isHomePageRoute = router.pathname === '/dashboard';
  const sideBarHomePageBorderTop = isHomePageRoute && isMenuOpen;

  return (
    <>
      <Show below="lg">
        <Box
          onClick={handleToggleMenu}
          data-testid="backdrop"
          data-open={isMenuOpen}
          __css={style.backdrop}
        />
      </Show>
      <Flex
        data-open={isMenuOpen}
        __css={
          isHomePageRoute && !sideBarHomePageBorderTop
            ? style.dashboardRoot
            : sideBarHomePageBorderTop
              ? {
                  ...style.root,
                  borderTop: '1px solid black',
                }
              : style.root
        }
        className="scrollbar"
      >
        <Flex as={'ul'}>
          {data?.primaryNav.map((item: LinkType, index: number) => {
            const url =
              item?.fields?.href && urlArray.includes(item?.fields?.href)
                ? item.fields.href
                : '#';
            const isActive = url === currentUrl;
            const isYourJourney = item?.fields?.iconName === 'arrowForward'; // temporary so that it works for QA and UAT
            return (
              <Fragment key={index}>
                {isYourJourney ? (
                  <>
                    <Steps
                      handleToggleMenu={handleToggleMenu}
                      steps={serviceStages}
                      currentSelected={currentSelected}
                      setCurrentSelected={setCurrentSelected}
                      title={item.fields.label}
                    />
                    <Divider sx={{ border: '1px solid #C3C3C3', mb: '10px' }} />
                  </>
                ) : (
                  <Flex data-active={isActive} as={'li'}>
                    <Link onClick={handleLinkOpen} href={url}>
                      {item?.fields?.iconName && (
                        <Icon
                          className="icon"
                          name={item?.fields?.iconName}
                          sx={style.icon}
                        />
                      )}
                      <Text as={'span'}>{item?.fields?.label}</Text>
                    </Link>
                  </Flex>
                )}
              </Fragment>
            );
          })}
          {data && (
            <Hide above="lg">
              <Link sx={style.link} href={'/logout'}>
                <Icon name="signOut" sx={style.iconSignout} />
                <Text as="span">{t('sign_out')}</Text>
              </Link>
            </Hide>
          )}
        </Flex>
      </Flex>
    </>
  );
};

export default DashboardSidebar;

// import React, { Fragment, useContext, useMemo, useState } from 'react';

// import { Box, Divider, Flex, Hide, Show } from '@chakra-ui/react';
// import { useRouter } from 'next/router';

// import style from './Sidebar.styled';
// import Steps from './Steps';

// import { Icon, Link, Text } from '@/components';
// import { HeaderDataType } from '@/components/layouts/SidebarLayout/SidebarLayout.type';
// import { fetchUrlFromWindowPathName, urlArray } from '@/helpers/utils';
// import useTranslation from '@/hooks/useTranslate';
// import { DashboardContext } from '@/providers/DashboardContext';
// import { Context } from '@/providers/MainContext';
// import { LinkType } from '@/types/ContentFul.type';

// interface sideBarProps {
//   isMenuOpen: boolean;
//   setIsMenuOpen: any;
//   data?: HeaderDataType;
// }

// const DashboardSidebar = ({
//   isMenuOpen,
//   setIsMenuOpen,
//   data,
// }: sideBarProps) => {
//   const { t } = useTranslation();
//   const { serviceStages } = useContext(DashboardContext);
//   const { locale } = useContext(Context);
//   const [currentSelected, setCurrentSelected] = useState(0);
//   const router = useRouter();
//   const handleToggleMenu = () => {
//     setCurrentSelected(-1);
//     setIsMenuOpen.toggle();
//   };

//   const handleLinkOpen = () => {
//     handleToggleMenu();
//   };

//   const currentUrl = useMemo(
//     () => fetchUrlFromWindowPathName(router?.pathname, locale),
//     [router.pathname, locale]
//   );

//   const sideBarHomePageBorderTop = router.route === '/dashboard' && isMenuOpen;

//   return (
//     <>
//       <Show below="lg">
//         <Box
//           onClick={handleToggleMenu}
//           data-testid="backdrop"
//           data-open={isMenuOpen}
//           __css={style.backdrop}
//         />
//       </Show>
//       <Flex
//         data-open={isMenuOpen}
//         __css={{
//           ...style.root,
//           borderTop: sideBarHomePageBorderTop ? '1px solid black' : 'none',
//         }}
//         className="scrollbar"
//       >
//         <Flex as={'ul'}>
//           {data?.primaryNav.map((item: LinkType, index: number) => {
//             const url =
//               item?.fields?.href && urlArray.includes(item?.fields?.href)
//                 ? item.fields.href
//                 : '#';
//             const isActive = url === currentUrl;
//             const isYourJourney = item?.fields?.iconName === 'arrowForward'; // temporary so that it works for QA and UAT
//             return (
//               <Fragment key={index}>
//                 {isYourJourney ? (
//                   <>
//                     <Steps
//                       handleToggleMenu={handleToggleMenu}
//                       steps={serviceStages}
//                       currentSelected={currentSelected}
//                       setCurrentSelected={setCurrentSelected}
//                       title={item.fields.label}
//                     />
//                     <Divider sx={{ border: '1px solid #C3C3C3', mb: '10px' }} />
//                   </>
//                 ) : (
//                   <Flex data-active={isActive} as={'li'}>
//                     <Link onClick={handleLinkOpen} href={url}>
//                       {item.fields.iconName && (
//                         <Icon
//                           className="icon"
//                           name={item.fields.iconName}
//                           sx={style.icon}
//                         />
//                       )}
//                       <Text as={'span'}>{item.fields.label}</Text>
//                     </Link>
//                   </Flex>
//                 )}
//               </Fragment>
//             );
//           })}
//           {data && (
//             <Hide above="lg">
//               <Link sx={style.link} href={'/logout'}>
//                 <Icon name="signOut" sx={style.iconSignout} />
//                 <Text as="span">{t('sign_out')}</Text>
//               </Link>
//             </Hide>
//           )}
//         </Flex>
//       </Flex>
//     </>
//   );
// };

// export default DashboardSidebar;
